module.exports = __webpack_public_path__ + "static/media/CourseStatus_NotStarted.9312ca12.svg";